module.exports=function(scope){ return `<div class="global-account-menu-button">
   <a class="icon-container">
     <div>
       ${scope.accountName}
       ${scope.caretIcon}
     </div>
   </a>
   <div class="items-container" hidden>
     <ul class="items-list">
       <li class="arrow"><span></span></li>
       <li><a href="${scope.accountUrl}" id="global-account-menu-my-account-link">My Account</a></li>
       ${scope.masterAccountUrl ? `<li><a href="${scope.masterAccountUrl}" id="global-account-menu-master-account-link">My CenturyLink Master Account</a></li>` : ''}
       <li role="separator" class="divider"></li>
       <li><a href="${scope.logoutUrl}" id="global-account-menu-sign-out-link">Sign Out</a></li>
     </ul>
   </div>
</div>
`};


// WEBPACK FOOTER //
// ./src/templates/global-account-menu.tpl.html